import PropTypes from 'prop-types';

export const DateType = Object.freeze({
    FROM: 'FROM',
    UNTIL: 'UNTIL',
});


export const DateTypeProp = PropTypes.oneOf(Object.values(DateType));
export const DateTypeDefault = DateType.DEPARTURE;
